export default {
  root: {
    class: ["flex justify-between items-start w-full"],
  },
};
